import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categories } from "@/mocks/categories";
import ArticleCard from "@/components/base/ArticleCard";

export default function PopularArticles() {
  const popularArticles = articles.slice(0, 6);
  const getCategoryName = (slug: string) =>
    categories.find((c) => c.slug === slug)?.name || slug;

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门文章推荐
            </h2>
            <p className="text-foreground-600 text-sm">
              精选最受欢迎的「第一次」指南，助你从容应对
            </p>
          </div>
          <Link
            to="/category/career"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {popularArticles.map((article) => (
            <ArticleCard
              key={article.id}
              slug={article.slug}
              title={article.title}
              category={article.category}
              excerpt={article.excerpt}
              author={article.author}
              publishDate={article.publishDate}
              readTime={article.readTime}
              imageUrl={article.imageUrl}
              categoryName={getCategoryName(article.category)}
            />
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/career"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}